import { render, staticRenderFns } from "./FClientFileAutoCompleteField.vue?vue&type=template&id=64d48efb&"
import script from "./FClientFileAutoCompleteField.vue?vue&type=script&lang=ts&"
export * from "./FClientFileAutoCompleteField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports